import * as d3 from "d3"
import * as moment from "moment";



export function drawMarginalHistogram(theDataSet, c, d, e) {
    DOMtarget = c;
    vizWitdh = d;
    vizHeigth = e;

    setDimensions()
    drawBase()
    drawChart(theDataSet, false)
}

export function redrawChart(theDataSet) {
    // Do we need to remove dots and historgram?
    drawChart(theDataSet, true)
    // redraw(theDataSet)
}




let dataset, DOMtarget, vizWitdh, vizHeigth
let dimensions
let wrapper, dotsGroup, bounds

let dots

const colorScaleYear = 2000

const xAccessor = (d, i) => {
    return d.temperatureMin

}
const yAccessor = d => d.temperatureMax

const cWinter = "#5ef9f4"
const cSpring = "#83f446"
const cSummer = "#ff0213"
const cAutumn = "#6c17a5"
const colorArray = [cWinter, cSpring, cSummer, cAutumn]
const colorArrayExtended = [cWinter, cSpring, cSummer, cAutumn, cWinter]


const parseDate = d3.timeParse("%Y-%m-%d")

const colorAccessor = d => {
    let theDate = moment.unix(d.dateTime.seconds).format("YYYY-MM-DD")
    return parseDate(theDate).setYear(colorScaleYear)
}

const colorScale = d3.scaleSequential()
    .domain([
        d3.timeParse("%m/%d/%Y")(`1/1/${colorScaleYear}`),
        d3.timeParse("%m/%d/%Y")(`12/31/${colorScaleYear}`),
    ])
    .interpolator(d3.interpolateRgbBasisClosed(colorArray))

function setDimensions() {
    // Dimensions
    dimensions = {
        width: vizWitdh,
        height: vizHeigth,
        margin: {
            top: 110,
            right: 120,
            bottom: 140,
            left: 70,
        },
        histogramMargin: 5,
        histogramHeight: 90,
        legendHeight: 40,
        legendWidth: null,
        legendMargin: 35
    }
    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom

    // Create a square of the lower value
    const square = d3.extent([dimensions.boundedWidth, dimensions.boundedHeight])
    dimensions.boundedWidth = square[0]
    dimensions.boundedHeight = square[0]
    dimensions.legendWidth = square[0]
}

function drawBase() {

    // create chart area
    wrapper = d3.select(DOMtarget)
        .append("svg")
        .attr("width", dimensions.width)
        .attr("height", dimensions.height)
        .attr("x", 0)
        .attr("y", 0)
        .attr("class", "bound")
        .attr("id", "d3-root")

    bounds = wrapper.append("g")
        .style("transform", `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)
        .attr("x", 0)
        .attr("y", 0)

    // Background- color
    bounds.append("rect")
        .attr("height", dimensions.boundedHeight)
        .attr("width", dimensions.boundedWidth)
        .attr("fill", "#FFFFFF")
        .attr("class", "scatterplot")

    dotsGroup = bounds.append("g")

    // Source
    const attribution = wrapper.append("a")
        .attr("xlink:href", "https://darksky.net/poweredby/")
        .attr("class", "attribution")
        .append("rect")
        .attr("x", 10)
        .attr("y", dimensions.height-25)
        .attr("height", 40)
        .attr("width", 100)
        .attr("fill", "transparent")
        .attr("opacity", 0.2)


        wrapper.append("text")
        .text("Powered by Dark Sky")
        .style("fill", "black")
        .attr("x", 10)
        .attr("y", dimensions.height-10)
        .attr("class", "attribution")
        .style("pointer-events", "none")

}


function drawChart(newDataset, redraw) {

    // update dataset
    dataset = newDataset

    // create scales
    const temperatureExtent = d3.extent(
        [
            ...dataset.map(xAccessor),
            ...dataset.map(yAccessor)
        ]
    )

    const xScale = d3.scaleLinear()
        .domain(temperatureExtent)
        .range([0, dimensions.boundedWidth])
        .nice()

    const yScale = d3.scaleLinear()
        .domain(temperatureExtent)
        .range([dimensions.boundedHeight, 0])
        .nice()

    const tEnter = d3.transition()
        .duration(1500)
        .ease(d3.easeCubicOut)  // easeBackOut

    const tExit = d3.transition()
        .duration(400)
        .ease(d3.easeCubicOut)  // easeBackOut

    const drawDots = (dataset) => {

        dots = dotsGroup.selectAll("circle")
            .data(dataset)

        dots.exit().transition(tExit)
            .attr("fill-opacity", 0.1)
            .attr("cx", dimensions.boundedWidth / 2)
            .attr("cy", dimensions.boundedHeight / 2)
            .remove()

        dots.transition(tEnter)
            .attr("cx", d => xScale(xAccessor(d)))
            .attr("cy", d => yScale(yAccessor(d)))
            .style("fill", d => colorScale(colorAccessor(d)))

        dots.enter().append("circle")
            .attr("cx", dimensions.boundedWidth / 2) // define position before enter
            .attr("cy", dimensions.boundedHeight / 2)
            .attr("r", 0)
            .attr("fill", "white")
            .attr("fill-opacity", 0.1)
            .transition(tEnter) // then transition as for update or exit
            .attr("r", 3)
            .attr("fill-opacity", 1)
            .attr("cx", d => xScale(xAccessor(d)))
            .attr("cy", d => yScale(yAccessor(d)))
            .attr("class", "dot")
            .style("fill", d => {
                
                return colorScale(colorAccessor(d))
            })

    }
    drawDots(dataset)

    // **** HISTORGRAM ****


    // replace the histogram
    bounds.selectAll(".histogram").remove()


    // TOP Histogram
    const topHistogramBounds = bounds.append("g")
        .attr("transform", `translate(0, ${-dimensions.histogramHeight - dimensions.histogramMargin})`)
        .attr("class", "histogram")

    const topHistogramGenerator = d3.histogram()
        .domain(xScale.domain())
        .value(xAccessor)
        .thresholds(20)

    const topHistogramBins = topHistogramGenerator(dataset)

    const topHistogramYScale = d3.scaleLinear()
        .domain(d3.extent(topHistogramBins, d => d.length))
        .range([dimensions.histogramHeight, 0])

    const topHistogramLineGenerator = d3.area()
        .x(d => xScale((d.x0 + d.x1) / 2))
        .y0(dimensions.histogramHeight)
        .y1(d => topHistogramYScale(d.length))
        .curve(d3.curveBasis)

    // check how to animate path
    topHistogramBounds
        .append("path")
        .attr("d", d => topHistogramLineGenerator(topHistogramBins))
        .attr("class", "histogram-area")


    // RIGHT Histogram (maximum Temp or y Scale)
    const rightHistogramGenerator = d3.histogram()
        .domain(yScale.domain())
        .value(yAccessor)
        .thresholds(20)

    const rightHistogramBins = rightHistogramGenerator(dataset)

    const rightHistogramXScale = d3.scaleLinear()
        .domain(d3.extent(rightHistogramBins, d => d.length))
        .range([dimensions.histogramHeight, 0])

    const rightHistogramLineGenerator = d3.area()
        .x(d => yScale((d.x0 + d.x1) / 2))
        .y0(dimensions.histogramHeight)
        .y1(d => rightHistogramXScale(d.length))
        .curve(d3.curveBasis)




    const rightHistogramBounds = bounds.append("g")
        .style("transform", `translate(${+dimensions.boundedWidth + dimensions.histogramHeight + dimensions.histogramMargin}px,0px) rotate(90deg)`)
        .attr("class", "histogram")



    rightHistogramBounds.append("path")
        .attr("d", d => {
            return rightHistogramLineGenerator(rightHistogramBins)
        })
        .transition()
        .duration(2500)
        // .attr("d", "M 10,10 h 10")
        .attr("class", "histogram-area")


    // **** PERIPHEALS *****


    let xAxis = bounds.append("g")
        .attr("class", "x-axis")
        .style("transform", `translateY(${dimensions.boundedHeight}px)`)

    let xAxisLabel = bounds.append("text")
        .attr("class", "x-axis-label")
        .style("transform", `translateY(${dimensions.boundedHeight}px)`)

    const xAxisGenerator = d3.axisBottom()
        .scale(xScale)
        .ticks(4)

    xAxis = bounds.select(".x-axis")
        .transition(tEnter)
        .call(xAxisGenerator)

    xAxisLabel = bounds.select(".x-axis-label")
        .attr("x", dimensions.boundedWidth / 2)
        .attr("y", dimensions.margin.left / 2 + 10) // Same spacing than for y-axis + 10 for the ticks
        .text("Minimum Temperature (°C)")



    // y-axis

    let yAxis = bounds.append("g")
        .attr("class", "y-axis")

    let yAxisLabel = bounds.append("text")
        .attr("class", "y-axis-label")

    const yAxisGenerator = d3.axisLeft()
        .scale(yScale)
        .ticks(4)

    yAxis = bounds.select(".y-axis")
        .transition(tEnter)
        .call(yAxisGenerator)

    yAxisLabel = bounds.select(".y-axis-label")
        .attr("x", -dimensions.boundedHeight / 2)
        .attr("y", -dimensions.margin.left / 2)
        .text("Maximum Temperature (°C)")



    // bounds.append("g")
    //     .attr("class", "x-axis")
    //     .style("transform", `translateY(${dimensions.boundedHeight}px)`)
    //     .append("text")
    //     .attr("class", "x-axis-label")


    // const xAxisGenerator = d3.axisBottom()
    //     .scale(xScale)

    // const xAxis = bounds.select(".x-axis")
    //     .transition(updateTransition)
    //     .call(xAxisGenerator)


    // const xAxisLabel = xAxis.select(".x-axis-label")
    //     .attr("x", dimensions.boundedWidth / 2)
    //     .attr("y", dimensions.margin.bottom - 10)
    //     .text(metric)




    // Voronoi

    const voronoiGenerator = d3.voronoi()
        .x(d => xScale(xAccessor(d)))
        .y(d => yScale(yAccessor(d)))
        .extent([
            [0, 0],
            [dimensions.boundedWidth, dimensions.boundedHeight]
        ])

    const voronoiPolygons = voronoiGenerator.polygons(dataset)

    const voronoi = bounds.selectAll(".voronoi")
        .data(voronoiPolygons)

    voronoi.exit()
        .remove()

    voronoi
        .enter().append("polygon")
        .on("mouseenter", onVoronoiMouseEnter)
        .on("mouseleave", onVoronoiMouseLeave)
        .transition(tEnter)
        .attr("class", "voronoi")
        // .style("stroke", "red")
        .attr("points", (d = []) => (
            d.map(point => (
                point.join(",")
            )).join(" ")
        ))

    voronoi
        .on("mouseenter", onVoronoiMouseEnter)
        .on("mouseleave", onVoronoiMouseLeave)
        .transition(tEnter)
        .attr("class", "voronoi")
        // .style("stroke", "green")
        .attr("points", (d = []) => (
            d.map(point => (
                point.join(",")
            )).join(" ")
        ))




    const tooltip = d3.select("#tooltip-sp")

    // HISTROGRAMM ROLLOVER

    const hoverElementsGroup = bounds.append("g")
        .attr("opacity", 0)

    const horizontalPath = hoverElementsGroup.append("path")
        .attr("class", "hover-line")

    const horizontalPathGenerator = d3.line()
        .x((d, i) => i ? d.x - dimensions.margin.left : dimensions.width - dimensions.margin.right)
        .y(d => d.y - dimensions.margin.top)

    const verticalPath = hoverElementsGroup.append("path")
        .attr("class", "hover-line")

    const verticalPathGenerator = d3.line()
        .x(d => d.x - dimensions.margin.left)
        .y((d, i) => i ? d.y - dimensions.margin.top : -dimensions.histogramHeight)


    // HISTROGRAMM ROLLOVER

    function onVoronoiMouseEnter(voronoiDatum) {
        const datum = voronoiDatum.data

        let theDate = moment.unix(datum.dateTime.seconds).format("YYYY-MM-DD")

        dotsGroup.append("circle")
            .attr("class", "tooltipDot")
            .attr("cx", d => xScale(xAccessor(datum)))
            .attr("cy", d => yScale(yAccessor(datum)))
            .attr("r", 7)
            .style("pointer-events", "none")

        // *** TOOLTIP ***

        const dateParser = d3.timeParse("%Y-%m-%d")
        const formatDate = d3.timeFormat("%B %-d, %Y")
        tooltip.select("#date")
            .text(formatDate(dateParser(theDate)))

        tooltip.select("#temperature")
            .text(datum.temperatureMin + "°C / " + datum.temperatureMax + "°C")

        const x = xScale(xAccessor(datum))
            + dimensions.margin.left
        const y = yScale(yAccessor(datum))
            + dimensions.margin.top

        tooltip.style("transform", `translate(`
            + `calc( -50% + ${x}px),`
            + `calc(-100% + ${y - 8}px)`
            + `)`)

        tooltip.style("opacity", 1)

        // Histogram Hover
        horizontalPath.attr("d", horizontalPathGenerator([{ y }, { x, y }]))
        verticalPath.attr("d", verticalPathGenerator([{ x }, { x, y }]))

        hoverElementsGroup.style("opacity", 1)

    }

    function onVoronoiMouseLeave() {
        d3.selectAll(".tooltipDot")
            .remove()

        hoverElementsGroup.style("opacity", 0)
        tooltip.style("opacity", 0)
    }


    // *** ######################### ***
    // LEGEND

    const legendGroup = bounds.append("g")
        .attr("class", "legendGroup")
        .attr("transform", `translate(${
            0
            },${
            dimensions.boundedHeight + dimensions.margin.bottom - dimensions.legendHeight - dimensions.legendMargin
            })`)

    const defs = wrapper.append("defs")



    const legendGradientId = "legend-gradient"
    defs.append("linearGradient")
        .attr("id", legendGradientId)
        .selectAll("stop")
        .data(colorArrayExtended)
        .enter().append("stop")
        .attr("stop-color", (d, i) => colorArrayExtended[i])
        .attr("offset", (d, i) => `${
            i * 100 / (colorArrayExtended.length - 1)
            }%`)

    const legendGradient = legendGroup.append("rect")
        .attr("height", dimensions.legendHeight)
        .attr("width", dimensions.boundedWidth)
        .style("fill", `url(#${legendGradientId})`)

    const tickValues = [
        // d3.timeParse("%m/%d/%Y")(`1/1/${colorScaleYear}`),
        d3.timeParse("%m/%d/%Y")(`3/1/${colorScaleYear}`),
        d3.timeParse("%m/%d/%Y")(`6/1/${colorScaleYear}`),
        d3.timeParse("%m/%d/%Y")(`9/1/${colorScaleYear}`),
        // d3.timeParse("%m/%d/%Y")(`12/15/${colorScaleYear}`),
    ]


    const legendTickScale = d3.scaleLinear()
        .domain(colorScale.domain())
        .range([0, dimensions.legendWidth])

    legendGroup.selectAll(".legend-value")
        .data(tickValues)
        .enter().append("text")
        .attr("class", "legend-value")
        .attr("x", legendTickScale)
        .attr("y", dimensions.legendHeight / 2 + 5)
        .text(d3.timeFormat("%b"))



    // LEGEND END
    // *** ######################### ***


    // *** ######################### ***
    // LEGEND HIGHLIGHT


    legendGradient
        .on("mousemove", onLegendMouseMove)
        .on("mouseleave", onLegendMouseLeave)

    const legendHighlightBarWidth = dimensions.legendWidth * 0.05
    const legendHighlightGroup = legendGroup.append("g")
        .attr("opacity", 0)

    legendHighlightGroup.append("rect")
        .attr("class", "legend-highlight-bar")
        .attr("width", legendHighlightBarWidth)
        .attr("height", dimensions.legendHeight + 4)
        .attr("y", -2)

    const legendHighlightText = legendHighlightGroup.append("text")
        .attr("class", "legend-highlight-text")
        .attr("x", legendHighlightBarWidth / 2)
        .attr("y", -10)

    const hoverTopHistogram = topHistogramBounds.append("path")
    const hoverRightHistogram = rightHistogramBounds.append("path")



    function onLegendMouseMove(e) {

        // SLIDER
        const x = d3.mouse(this)

        // place slider first, then base scale on width of slider
        let barX = x[0] - legendHighlightBarWidth / 2

        if (barX < 0) { barX = 0 } // prevent scrolling outside - left
        if (barX > dimensions.legendWidth - legendHighlightBarWidth) { barX = dimensions.legendWidth - legendHighlightBarWidth } // prevent scrolling outside - right

        // scale based on highlight bar
        const minDateToHighlight = legendTickScale.invert(barX)
        const maxDateToHighlight = legendTickScale.invert(barX + legendHighlightBarWidth)

        legendHighlightGroup.style("opacity", 1)
            .style("transform", `translateX(${barX}px)`)

        legendHighlightText.text([
            d3.timeFormat("%b %d")(minDateToHighlight),
            d3.timeFormat("%b %d")(maxDateToHighlight),
        ].join(" - "))

        // DOTS
        dotsGroup
            .selectAll(".dot")
            .transition().duration(100)
            .style("opacity", 0.45)
            .attr("r", 2)


        // Slider Function 
        const getYear = d => +d3.timeFormat("%Y")(d)
        const isDayWithinRange = d => {
            const date = colorAccessor(d)

            if (getYear(minDateToHighlight) < colorScaleYear) {
                // if dates wrap around to previous year,
                // check if this date is after the min date
                return date >= new Date(minDateToHighlight).setYear(colorScaleYear)
                    || date <= maxDateToHighlight

            } else if (getYear(maxDateToHighlight) > colorScaleYear) {
                // if dates wrap around to next year,
                // check if this date is before the max date
                return date <= new Date(maxDateToHighlight).setYear(colorScaleYear)
                    || date >= minDateToHighlight

            } else {
                return date >= minDateToHighlight
                    && date <= maxDateToHighlight
            }
        }

        dotsGroup.selectAll(".dot")
            .filter(isDayWithinRange)
            .transition().duration(100)
            .style("opacity", 1)
            .attr("r", 7)

        // Histogram
        
        const xPos = barX + legendHighlightBarWidth / 2
        const hoveredDate = d3.isoParse(legendTickScale.invert(xPos))
        const hoveredDates = dataset.filter(isDayWithinRange)

        hoverTopHistogram.attr("d", d => (
            topHistogramLineGenerator(topHistogramGenerator(hoveredDates))
        ))
            .attr("fill", colorScale(hoveredDate))
            .attr("stroke", "white")
            .style("opacity", 1)

        hoverRightHistogram.attr("d", d => (
            topHistogramLineGenerator(topHistogramGenerator(hoveredDates))
        ))
            .attr("fill", colorScale(hoveredDate))
            .attr("stroke", "white")
            .style("opacity", 1)

    }

    function onLegendMouseLeave() {
        legendHighlightGroup
            .style("opacity", 0)

        dotsGroup.selectAll(".dot")
            .transition().duration(500)
            .style("opacity", 1)
            .attr("r", 3)

        hoverTopHistogram
            .style("opacity", 0)

        hoverRightHistogram
            .style("opacity", 0)
    }

}